// extracted by mini-css-extract-plugin
export default {"container":"d1qq","header":"SDIs","serviceItem":"hzR2","code":"D_7z","iconWrapper":"j95E","name":"HsQQ","cost":"tOvV","highlitedContainer":"bV_R"};